import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ShieldCheck, LayoutDashboard, Building2, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Platform Overview" },
  { to: "/admin/clients", icon: Building2, label: "Client Accounts" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-[#14130F] text-stone-200 flex font-body">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col fixed inset-y-0 border-r border-white/10 bg-[#1A1814]">
        <div className="h-16 flex items-center gap-2 px-6 border-b border-white/10">
          <span className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
            <ShieldCheck className="h-4.5 w-4.5 text-primary-foreground" strokeWidth={1.75} />
          </span>
          <div>
            <p className="text-sm font-heading font-semibold text-white leading-none">manage.kitchen</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-primary mt-1">Admin · Mandalay Media</p>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-primary text-primary-foreground" : "text-stone-400 hover:bg-white/5 hover:text-white"
                }`}>
              <n.icon className="h-4.5 w-4.5" strokeWidth={1.6} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2">
            <p className="text-sm font-medium text-white truncate">{user?.name}</p>
            <p className="text-xs text-stone-500 truncate">{user?.email}</p>
          </div>
          <Button data-testid="admin-logout" onClick={doLogout} variant="ghost"
            className="w-full justify-start text-stone-400 hover:bg-white/5 hover:text-white">
            <LogOut className="h-4 w-4 mr-2" /> Log out
          </Button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="h-16 border-b border-white/10 bg-[#1A1814]/80 backdrop-blur-xl sticky top-0 z-30 flex items-center justify-between px-6">
          <div className="flex items-center gap-2 lg:hidden">
            <ShieldCheck className="h-5 w-5 text-primary" />
            <span className="font-heading font-semibold text-white">manage.kitchen</span>
          </div>
          <span className="text-xs uppercase tracking-[0.2em] text-stone-500 ml-auto">Platform Control Room</span>
        </header>
        <main className="p-4 sm:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
